
export enum enumEraseTransactionCode {
  'AUTO' = 1,
  'ATMC',
  'BNKC',
  'CASH',
  'CHCK',
  'CRDC',
  'DBTC',
  'DRFT',
  'FXCH',
  'INST',
  'INTR',
  'INTT',
  'LOAN',
  'WRTR',
  'CRDT'

}

export namespace enumEraseTransactionCode {
  export function values() {
    return Object.keys(enumEraseTransactionCode).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
